import React from "react";
import useSWR from "swr";
import { BlogApiUrls } from "../../Api/Auth/ApiUrls";
import { noAuthfetcher } from "../../Api/swrConfig";
import { Loader } from "../../Components/Common/Loader";
import Button from "../../Components/Common/Button";
import { Link } from "react-router-dom";
import { publicUrls } from "../../Api/Auth/AppUrls";

const BlogArchive = () => {
  const { data, isLoading, error } = useSWR(
    BlogApiUrls.list(""),
    noAuthfetcher
  );

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">
          Unable to load blogs right now. Please try again later.
        </p>
      </div>
    );
  }

  const blogs = data?.data || [];

  return (
    <div className="container mx-auto py-16 px-4">
      <h1 className="text-3xl font-semibold text-primary text-center mb-10">
        Blog Archive
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {blogs.map((blog) => (
          <div
            key={blog._id}
            className="border rounded-lg shadow-md overflow-hidden bg-white flex flex-col"
          >
            {blog.link && (
              <img
                src={blog.link}
                alt={blog.title}
                className="w-full h-56 object-cover"
              />
            )}
            <div className="p-6 space-y-4 flex-1 flex flex-col">
              <h2 className="text-2xl font-semibold text-gray-800">
                {blog.title}
              </h2>
              <div
                className="text-gray-600 text-sm flex-1"
                dangerouslySetInnerHTML={{
                  __html: blog.description?.slice(0, 300) || "",
                }}
              />
              <div className="flex justify-end">
                <Link to={publicUrls.Blog.replace(":slug", blog.slug)}>
                  <Button type="outline">Read Blog</Button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogArchive;
